import { Box, Button, Paper, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import Highcharts3D from "highcharts/highcharts-3d";
import HighchartsExporting from "highcharts/modules/exporting";
import HighchartsExportData from "highcharts/modules/export-data";
import NoRecordFound from "../../utils/NoRecordFound";
import { useNavigate } from "react-router-dom";
export const data = [
  ["Task", "Hours per Day"],
  ["Main Engines", 30],
  ["Auxiliary Engines", 20],
  ["Mooring System", 25],
  [" Communication Equipment", 25],
];
export const options = {
  // title: "My Daily Activities",
  is3D: true,
  legend: { position: "none" },
  colors: ["#F65464", "#1BC5BD", "#8A50FC", "#FFA800"],
};
Highcharts3D(Highcharts);
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
const PieChart = (Props) => {
  const navigate = useNavigate();
  const [categoryData, setCategoryData] = useState({
    total: 0,
    data: [],
  });
  const chartContainerRef = useRef(null);
  const handleViewChart1 = () => {
    Props.setIsFullScreenPiechart(true);
  };
  // Define a color mapping for each category
  const colorMapping = ["#FFA800", "#8A50FC", "#1BC5BD", "#F65464", "#3699FF"];
  useEffect(() => {
    if (Props.data && chartContainerRef.current) {
      const sortedData = Props.data.sort((a, b) => b.count - a.count);
      const top4Data = sortedData.slice(0, 4);
      const remainingData = sortedData.slice(4);
      let total = 0;
      let dataList = [];
      top4Data.forEach((item, index) => {
        total += item?.count;
        dataList.push({
          name: item?.name,
          y: item?.count,
          color: colorMapping?.[index], // Use colorMapping for top 4 categories
        });
      });
      if (remainingData.length > 0) {
        const otherCount = remainingData.reduce(
          (acc, item) => acc + item.count,
          0
        );
        total += otherCount;
        // Add "Other" section with light gray color
        dataList.push({
          name: "Others",
          y: otherCount,
          color: "#D4D4D4", // Light gray color for "Other" section
        });
      }
      setCategoryData({
        data: dataList,
        total: total,
      });
      const PieChartData = {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 60,
            beta: 0,
          },
        },
        title: {
          text: "",
          align: "left",
        },
        exporting: false,
        subtitle: {
          text: "",
          align: "left",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          pointFormat: " <b>{point.percentage:.1f}%</b>",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            depth: 35,
            dataLabels: {
              enabled: false,
            },
          },
        },
        series: [
          {
            type: "pie",
            name: "",
            data: dataList,
          },
        ],
      };
      try {
        Highcharts.chart(chartContainerRef.current, PieChartData);
      } catch (error) {
        console.error("Error initializing Highcharts:", error);
      }
    }
  }, [Props.data]);
  return (
    <>
      <Paper
        sx={{
          borderRadius: "12px",
          height: "100%",
        }}
      >
        <Box
          sx={{
            padding: "20px 20px 20px 20px",
            height: "45rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "17px",
                  color: "#464E5F",
                }}
              >
                Category of Defects
              </Typography>
              <Typography
                sx={{
                  fontWeight: "500",
                  fontSize: "12px",
                  color: "#B5B5C3",
                }}
              >
                Top 5 Category
              </Typography>
            </Box>
            <Box>
              <Button
                disabled={Props.data && Props.data.length > 0 ? false : true}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  border: "1px solid #E5F1EB",
                  backgroundColor: "#E5F1EB",
                  padding: "8px 15px 5px 15px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#20724E",
                  ":hover": {
                    backgroundColor: "#E5F1EB",
                  },
                }}
                onClick={handleViewChart1}
              >
                View All
              </Button>
            </Box>
          </Box>
          {/* <Divider sx={{ margin: "20px 0" }} /> */}
          <Box>
            {Props.data && Props.data.length > 0 ? (
              <div
                ref={chartContainerRef}
                style={{ width: "100%", height: "400px" }}
              ></div>
            ) : (
              <NoRecordFound />
            )}
          </Box>
          {Props.data && Props.data.length > 0 && (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridGap: "20px",
              }}
            >
              {/* {categoryData.data.map((item) => {
                return (
                  <Box>
                    <Typography
                      sx={{
                        color: item.color,
                        fontWeight: "600",
                        fontSize: "18px",
                      }}
                    >
                      {((item.y * 100) / categoryData.total).toFixed(1)}%
                    </Typography>
                    <Typography
                      sx={{
                        textOverflow: "ellipsis",
                        // whiteSpace: "nowrap",
                        overflow: "hidden",
                      }}
                    >
                      {item.name}
                    </Typography>
                  </Box>
                );
              })} */}
              {categoryData.data.slice(0, 4).map((item) => (
                <Box sx={{ cursor: 'pointer' }} key={item.name} onClick={() => {
                  navigate("/defects", {
                    state: { DefectsOpen: null ,categoryDefectsdata: item.name,   }
                  });
                }}>
                  <Typography
                    sx={{
                      color: item.color,
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    {((item.y * 100) / categoryData.total).toFixed(1)}%
                  </Typography>
                  <Typography
                    sx={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                  >
                    {item.name}
                  </Typography>
                </Box>
              ))}
              {categoryData.data.length > 4 && (
                <Box key="other">
                  <Typography
                    sx={{
                      color: "gray", // You can customize the color for "Other"
                      fontWeight: "600",
                      fontSize: "18px",
                    }}
                  >
                    {categoryData.data
                      .slice(4)
                      .reduce(
                        (acc, item) =>
                          acc + (item.y * 100) / categoryData.total,
                        0
                      )
                      .toFixed(1)}
                    %
                  </Typography>
                  <Typography
                    sx={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                    }}
                  >
                    Others
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Paper>
    </>
  );
};
export default PieChart;
